export default {"src":"/_next/static/media/window-close-regular.0933118b.svg","height":512,"width":512};